'use strict';

module.exports = /* @ngInject */ function () {
	return {
		restrict: 'E',
		scope: {
			/**
			 * All options for the autocomplete dropdown and search
			 */
			options: '=',

			/**
			 * If a value needs to be preselected, it can be passed here.
			 *
			 * REMINDER:
			 * This works via two-way binding so if the value passed here was a variable and a new option has been selected
			 * the variable will be updated as well.
			 */
			value: '=',
			disabled: '=',

			/**
			 * Define a placeholder for the autocomplete input element
			 */
			placeholder: '@',

			/**
			 * For usage within a form it is mandatory to set the id attribute of the autocomplete input.
			 * This id can be passed here.
			 */
			inputId: '@',

			property: '@',

			onValueChange: '=',

			/**
			 * Function for server-side search (new v2 API)
			 */
			searchFunction: '&',

			/**
			 * Include value for cost centers and projects
			 */
			includeValue: '@'
		},
		templateUrl: `./${BUILD_PATH}/account-assignment-autocomplete.directive.html`,
		controller: /* @ngInject */ function ($scope) {

			// expose the scope of this directive to the parent directive
			$scope.$parent.$parent.accountAssignmentAutocompleteScope[$scope.inputId] = $scope;

			$scope.init = init;

			let oldItem;

			init();

			function init(){
				if(!$scope.property){
					$scope.property = 'key';
				}
				oldItem = $scope.value;
			}

			/**
			 * Search function that handles both server-side search and client-side filtering
			 * @param searchText - string to search by
			 * @returns Promise or filtered array
			 */
			$scope.searchAccountAssignments = searchAccountAssignments;
			let filteredOptions = [];
			let searchTimeout;
			$scope.searchText = '';

			$scope.onEnterOrTabPressed = onEnterOrTabPressed;

			$scope.change = onChange;

			function onChange(event){
				if($scope.onValueChange){
					$scope.onValueChange({old: oldItem, new: event});
				}
				oldItem = event;
			}

			function onEnterOrTabPressed() {
				if(filteredOptions && filteredOptions.length > 0 && $scope.searchText) {
					$scope.value = filteredOptions[0];
					onChange(filteredOptions[0])
				}
			}

			/**
			 * Main search function that handles both server-side search and client-side filtering
			 * @param searchText
			 * @return {Promise|Array}
			 */
			function searchAccountAssignments(searchText) {
				$scope.searchText = searchText;
				
				// If searchFunction is provided, use server-side search
				if ($scope.searchFunction) {
					return debouncedServerSearch(searchText);
				} else {
					// Fallback to client-side filtering for backward compatibility
					return filterOptionsClientSide(searchText);
				}
			}

			/**
			 * Debounced server-side search
			 * @param searchText
			 * @return {Promise}
			 */
			function debouncedServerSearch(searchText) {
				return new Promise((resolve) => {
					if (searchTimeout) {
						clearTimeout(searchTimeout);
					}
					
					searchTimeout = setTimeout(() => {
						if (!searchText || searchText.length < 1) {
							// Load first 50 entries when no search text
							$scope.searchFunction({query: ''}).then((results) => {
								filteredOptions = results || [];
								resolve(filteredOptions);
							}).catch(() => {
								filteredOptions = [];
								resolve(filteredOptions);
							});
						} else {
							$scope.searchFunction({query: searchText}).then((results) => {
								filteredOptions = results || [];
								
								// Check for auto-selection: if only one result and it matches the search text,
								// trigger the change event to enable auto-selection behavior
								if (filteredOptions.length === 1 && searchText.length > 0) {
									const singleResult = filteredOptions[0];
									const displayValue = singleResult[$scope.property];
									
									// If the search text matches the beginning of the display value,
									// this is likely an auto-selection scenario
									if (displayValue && displayValue.toLowerCase().startsWith(searchText.toLowerCase())) {
										// Small delay to allow Angular Material to process the results
										setTimeout(() => {
											if (!$scope.value || $scope.value !== singleResult) {
												$scope.value = singleResult;
												onChange(singleResult);
												$scope.$apply();
											}
										}, 50);
									}
								}
								
								resolve(filteredOptions);
							}).catch(() => {
								filteredOptions = [];
								resolve(filteredOptions);
							});
						}
					}, 300); // 300ms debounce delay
				});
			}

			/**
			 * Client-side filtering for backward compatibility
			 * @param searchText
			 * @return {Array}
			 */
			function filterOptionsClientSide(searchText) {
				if (!searchText) {
					filteredOptions = $scope.options ? $scope.options.slice() : [];
					return filteredOptions;
				} else {
					filteredOptions = $scope.options ? $scope.options.slice()
						.filter((option) => option[$scope.property]
							.toLowerCase()
							.includes(searchText.toLowerCase())) : [];
					return filteredOptions;
				}
			}

		}

	}
}
